import {
  AfterContentInit,
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ContentChildren,
  Directive,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  OnDestroy,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
  ViewContainerRef,
  HostBinding,
  AfterViewInit
} from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { TabsDropdownTemplateComponent } from './tabsDropdown.template';

@Component({
  selector: 'axis-tab-wrapper',
  templateUrl: './tabgroup.component.html',
  host: { '[class.axis-tabs-wrapper]': 'true' }
})

export class TabWrapperComponent {
  // tslint:disable-next-line: no-input-rename
  @Input('data-kind') kind = 'primary'; // To apply css in ng9, input name should be data-kind.
  // @HostBinding('class.axis-tabs-wrapper') axisTabsWrapper = true;
  constructor() { }
}

@Component({
  selector: 'axis-tab-set',
  templateUrl: './tabset.component.html'
})

export class TabSetComponent implements OnInit, OnDestroy, AfterContentInit, AfterViewChecked {
  private contentVisible = false;
  public activeDropdown: any;
  public dkind = 'icon';
  public dicon = 'more_vert';
  public dropdownTabs: Array<any> = [];
  public dropdownWidth: number;
  public isdropDown = false;
  public isTabContent = false;
  public tab: Array<any> = [];
  public resizeSubscription: Subscription;
  public tabsDropdownTemplate = TabsDropdownTemplateComponent;
  tabIndex = 0;

  @ContentChildren(forwardRef(() => GetTabOptionsDirective), {
    descendants: false
  }) tabOptionsRef: QueryList<any>;
  @ContentChildren(forwardRef(() => TabComponent)) tabs: any;

  @Input() ariaLabel: string;
  @Input() responsive = true;
  @Input() isMobile = false;
  @Input() options: any;
  @Input() ucid = '';
  @Input() vertical: boolean;
  @Input() isPopup = true;

  @ViewChild('tabsDropdown', { static: false }) tabsDropdown: any;
  @Output() onContentInit: EventEmitter<any> = new EventEmitter<any>();
  @Output() tabChange: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('tabRef', { static: true }) tabRef: ElementRef;
  @ViewChildren('tabItem', { read: ViewContainerRef }) tabItems: QueryList<ViewContainerRef>;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    public el: ElementRef
  ) {
    this.resizeSubscription = fromEvent(window, 'resize')
    .pipe(debounceTime(200))
    .subscribe((e) => {
      const tabWidths = this.calculateTabsWidth();
      const ulWidth = this.tabRef.nativeElement.clientWidth;
      const len = tabWidths.length - 1;
      let index = 0;
      for (let i = 0; i <= len; i++) {
        if (tabWidths[i] > ulWidth) {
          index = i;
          break;
        }
      }
      if (window.innerWidth > 576 || index !== 0) {
        this.reset();
      }
    });
  }

  ngOnInit(): void {
    // generate a unique component id
    if (this.ucid) {
      this.ucid = this.ucid + '-';
    }
    this.ucid = this.ucid + (Math.random() + Math.random()).toString().replace('.', '');
  }

  ngAfterContentInit() {
    this.tab = Array.from(this.tabs.toArray());
    const readTabs = this.tabs.toArray();
    const activeTab = readTabs.find(tab => tab.active === true);
    if (!activeTab && readTabs.length > 0) {
      readTabs[0].addDataNested();
      readTabs[0].active = true;
      readTabs[0].isHidden = false;
      this.setTabContentClass();
      this.tabChange.emit(0);
      readTabs[0].onSelect.emit(0);
      this.tabIndex = 0;
    } else if (activeTab && readTabs.length > 0) {
      this.tabIndex = readTabs.indexOf(activeTab);
      this.setTabContentClass();
    }
    if (this.tabOptionsRef) {
      if (this.tabOptionsRef.first) {
        this.options = this.tabOptionsRef.first.templateRef || null;
      }
    }
    this.onContentInit.emit();
  }

  ngAfterViewChecked() {
    if (this.el.nativeElement.offsetParent && !this.contentVisible) {
      this.calculateListWidth();
       this.contentVisible = true;
    }
  }

calculateTabsWidth() {
  const tabWidths = [];
  const childrenCount = this.tabRef.nativeElement.children.length;
  for (let i = 0; i < childrenCount; i++) {
    const el = this.tabRef.nativeElement;
    if (el.children.length > 1) {
      const fMarginWidth = this.tabRef.nativeElement.children[0].getBoundingClientRect()
        .right;
      const sMarginWidth = this.tabRef.nativeElement.children[1].getBoundingClientRect()
        .left;
      const rMargin = sMarginWidth - fMarginWidth;
      if (i === 0) {
        tabWidths[i] = Math.ceil(el.children[i].clientWidth + rMargin);
      } else {
        tabWidths[i] = Math.ceil(
          el.children[i].clientWidth + tabWidths[i - 1] + rMargin
        );
      }
    }
  }
  return tabWidths;
}


reset() {
  this.tabs._results = this.tabs._results.concat(this.dropdownTabs);
  this.tab = Array.from(this.tabs.toArray());
  this.dropdownTabs = [];
  setTimeout(() => {
    this.calculateListWidth();
  });
}
  calculateListWidth() {
    const tabWidths = this.calculateTabsWidth();
    const ulWidth = this.tabRef.nativeElement.clientWidth;
    const len = tabWidths.length - 1;
    let index = 0;
    for (let i = 0; i <= len; i++) {
      if (tabWidths[i] > ulWidth) {
        index = i;
        break;
      }
    }
    this.dropdownTabs.reverse();
    this.isdropDown = true;
    if (window.innerWidth < 576) {
      this.dkind = 'button';
      this.dicon = '';
      this.isMobile = true;
      this.dropdownTabs = this.responsive ?  this.tab.splice(0, this.tab.length) : [];
      this.tabs['_results'] = this.tab;
    } else if (index !== 0) {
      this.isMobile = false;
      this.dropdownTabs = this.tab.splice(index, len + 1 - index);
      this.tabs['_results'] = this.tab;
    }
    if (this.dropdownTabs.length > 0) {
      this.isdropDown = false;
      this.activeDropdown = this.dropdownTabs.find(tab => tab.active === true);
      if (this.activeDropdown && window.innerWidth > 576 ) { //when active dropdown tab is present set it at last visible tab. 
        const activeIndex = this.dropdownTabs.findIndex(tabItem => tabItem.active === true);
        this.dropdownTabs.splice(activeIndex, 1);
        this.tabs._results.unshift(this.activeDropdown);
        this.tabs._results = this.tabs._results.concat(this.dropdownTabs);
        this.tab = Array.from(this.tabs.toArray());
        for (let i = 0; i <= len; i++) {
          if (tabWidths[i] > ulWidth) {
            index = i;
            break;
          }
        }
        this.dropdownTabs.reverse();
        this.dropdownTabs = this.tab.splice(index, len + 1 - index);
        this.tabs['_results'] = this.tab;
        
        let firstTab = this.tabs._results[0];
        this.tabs._results.splice(0, 1);
        this.tabs._results.push(firstTab);
      }
    }

    if (!this.changeDetectorRef['destroyed']) {
      this.changeDetectorRef.detectChanges();
    }
  }

  changeActiveTab(tab: TabComponent, event?: Event) {
    if (event) {
      event.preventDefault(); // for enter/space key
    }
    const tabs = this.tabs.toArray();
    const dropdownTabs = this.dropdownTabs;

    for (const tb of tabs) {
      if (tb.active) {
        tb.onDeSelect.emit(tabs.indexOf(tb));
      }
      tb.active = false;
      tb.isHidden = true;
    }
    for (const tb of dropdownTabs) {
      if (tb.active) {
        tb.onDeSelect.emit(dropdownTabs.indexOf(tb));
      }
      tb.active = false;
      tb.isHidden = true;
    }

    tab.active = true;
    tab.isHidden = false;
    this.setTabContentClass();
    tab.addDataNested();
    if (tabs.indexOf(tab) === -1) {
      let index = dropdownTabs.indexOf(tab);
      if (tabs && tabs.length > 0) {
        index = tabs.length + dropdownTabs.indexOf(tab);
      }
      this.tabChange.emit(index);
      this.tabIndex = index;
    } else {
      this.tabChange.emit(tabs.indexOf(tab));
      this.tabIndex = tabs.indexOf(tab);
    }

    tab.onSelect.emit(tabs.indexOf(tab));
    const activeDropdown = this.dropdownTabs.find(tabItem => tabItem.active === true);
    if (activeDropdown && this.isPopup && window.innerWidth > 576) {
      let swappedTab = [];
      let dropdownTabs = [];
      let activeIndex;

      const tabLength = this.tabs._results.length - 1;
      activeIndex = this.dropdownTabs.findIndex(tabItem => tabItem.active === true);

      dropdownTabs = Array.from(this.dropdownTabs);
      dropdownTabs.splice(activeIndex, 1);
      swappedTab = this.tabs._results[tabLength];
      this.tabs._results.unshift(activeDropdown);

      this.dropdownTabs = dropdownTabs;
      this.tabsDropdown.dataProvider = this.dropdownTabs;
      this.reset();
      setTimeout(() => {
        let firstTab = this.tabs._results[0];
        this.tabs._results.splice(0, 1);
        this.tabs._results.push(firstTab);
      });

    }
  }

  setActiveTab(event: any, tab: TabComponent, index: number) {
    event.preventDefault();
    let newTab;
    let target;

    switch (event.key.toLocaleLowerCase()) {
      case 'arrowleft':
        newTab = index - 1;
        target = event.target.previousElementSibling;
        break;
      case 'arrowright':
        newTab = index + 1;
        target = event.target.nextElementSibling;
        break;
      // case 'delete': // not supported
      case 'end':
        newTab = -1;
        break;
      case 'home':
        newTab = this.tabs._results.length;
        break;
    }

    if (newTab < 0) { // wrap around to last tab
      newTab = this.tabs._results.length - 1;
      target = event.target.parentNode.lastElementChild;
    } else if (newTab >= this.tabs._results.length) { // wrap around to first tab
      newTab = 0;
      target = event.target.parentNode.firstElementChild;
    }
    this.tabIndex = newTab;
    target.focus();

    const tabs = this.tabs.toArray();
    const dropdownTabs = this.dropdownTabs; // for mobile

    for (const tb of tabs) {
      if (tb.active) {
        tb.onDeSelect.emit(tabs.indexOf(tb));
      }
      tb.active = false;
      tb.isHidden = true;
    }
    for (const tb of dropdownTabs) {
      if (tb.active) {
        tb.onDeSelect.emit(dropdownTabs.indexOf(tb));
      }
      tb.active = false;
      tb.isHidden = true;
    }

    tabs[newTab].active = true;
    tabs[newTab].isHidden = false;
    this.setTabContentClass();

    if (this.isTabContent) {
      if (tabs.indexOf(tab) === -1) {
        this.tabChange.emit(newTab);
        this.tabIndex = newTab;
      } else {
        this.tabChange.emit(tabs.indexOf(tab));
        this.tabIndex = tabs.indexOf(tab);
      }
    }

    tab.onSelect.emit(newTab);
  }

  setTabContentClass() {
    if (this.el.nativeElement['innerHTML'].indexOf('</axis-tab-content>') >= 0) {
      this.isTabContent = true;
    } else {
      this.isTabContent = false;
    }
  }

  // method called from Application, to set the tab active.
  setActiveTabWithIndex(index: number) {
    const tabs = this.tabs.toArray();
    tabs.forEach(tb => {
      tb.active = false;
      tb.isHidden = true;
    });
    const tab = this.tabs.toArray()[index];
    tab.active = true;
    tab.isHidden = false;
    this.setTabContentClass();
    this.tabChange.emit(tabs.indexOf(tab));
    tab.onSelect.emit(tabs.indexOf(tab));
  }

  trackByIndex(index: number): number {
    return index;
  }

  ngOnDestroy() {
    this.resizeSubscription.unsubscribe();
  }
}

@Component({
  selector: 'axis-tab',
  templateUrl: './tab.component.html',
  host: {
    'role':'tabpanel',
    'tabIndex':'0'
  }
})
export class TabComponent implements AfterContentInit, OnInit {

  @ContentChild(forwardRef(() => GetTabHeadingDirective), { static: true }) tabHeadingRef: any;

  @Input() active = false;
  @Input() error = false;
  @Input() ariaLabel: string;
  @Input() disabled = false;
  @Input('data-disabled') // property added in ng9 version to support existing applications using data-disabled.
  get dataDisabled() {
    return this.disabled;
  }
  set dataDisabled(value) {
    this.disabled = value;
  }
  @Input() header: TemplateRef<any>;
  @Input() heading: string;
  @Input() reference: string;

  @Output() onContentInit: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDeSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
  @HostBinding('hidden') isHidden = true;
  private isDataNested = false;
  constructor(private element: ElementRef) { }
  ngOnInit() {
    this.isHidden = !this.active;
    const contentElement = this.element.nativeElement.querySelector('axis-tab-content');
    if (contentElement && contentElement.attributes['data-nested']) {
      this.isDataNested = true;
      contentElement.removeAttribute('data-nested');
    }
  }

  addDataNested() {
    if (this.isDataNested) {
      this.element.nativeElement.parentElement.setAttribute('data-nested', '');
    } else {
      this.element.nativeElement.parentElement.removeAttribute('data-nested');
    }
  }

  ngAfterContentInit() {
    if (this.tabHeadingRef) {
      this.header = this.tabHeadingRef.templateRef || null;
    }
    this.onContentInit.emit();
    if (this.active) {
      this.addDataNested();
    }
  }
}

@Component({
  selector: 'axis-tab-heading',
  template: '<ng-content></ng-content>'
})
export class TabHeadingComponent {
 }

@Component({
  selector: 'axis-tab-content',
  template: '<ng-content></ng-content>'
})
export class TabContentComponent { }

@Component({
  selector: 'axis-tab-options',
  templateUrl: './taboptions.component.html'
})
export class TabOptionsComponent { }

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[getTabOptions]'
})
export class GetTabOptionsDirective {
  constructor(private templateRef: TemplateRef<any>) { }
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[setTabOptions]'
})
export class SetTabOptionsDirective {
  private _setTabOptions: TemplateRef<any>;

  constructor(public viewRef: ViewContainerRef) { }

  @Input()
  set setTabOptions(templateRef: TemplateRef<any>) {
    this._setTabOptions = templateRef;
    if (templateRef) {
      this.viewRef.createEmbeddedView(templateRef);
    }
  }
  get setTabOptions() {
    return this._setTabOptions;
  }
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[getTabHeading]'
})
export class GetTabHeadingDirective implements OnInit {
  constructor(private templateRef: TemplateRef<any>) { }
  ngOnInit() {
    // console.log(this.templateRef);
  }
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[setTabHeading]'
})
export class SetTabHeadingDirective {
  private _setTabHeading: TemplateRef<any>;

  constructor(public viewRef: ViewContainerRef) { }

  @Input()
  set setTabHeading(templateRef: TemplateRef<any>) {
    this._setTabHeading = templateRef;
    if (templateRef) {
      this.viewRef.createEmbeddedView(templateRef);
    }
  }
  get setTabHeading() {
    return this._setTabHeading;
  }
}
